import { ComponentPropsWithoutRef, useContext } from 'react';
import { TableCellContext } from 'components/table/TableContext';
import { EmptyData } from 'components/util';

interface TableCellDataOrEmptyProps extends Omit<ComponentPropsWithoutRef<'p'>, 'children'> {}
const TableCellDataOrEmpty = (props: TableCellDataOrEmptyProps) => {
    const { cell } = useContext(TableCellContext);

    return <p {...props}>{cell.getValue() ?? <EmptyData />}</p>;
};

export { TableCellDataOrEmpty };
